const relationships = [
	"SPOUSE",
	"CHILD",
	"STEP CHILD",
	"COURT-ORDERED DEPENDENT",
	"LEGAL CUSTODY CHILD",
	// "DISABLED CHILD",
	"GRANDCHILD",
	"OTHERS"
];

export const RELATIONSHIPS = relationships;

const relationship = {
	spouse: "SPOUSE",
	child: "CHILD",
	stepchild: "STEP CHILD",
	court_ordered_dependent: "COURT-ORDERED DEPENDENT",
	legal_custody_child: "LEGAL CUSTODY CHILD",
	disabled_child: "DISABLED CHILD",
	grandchild: "GRANDCHILD",
	others: "OTHERS"
};

export const RELATIONSHIP = relationship;
